import { createSelector } from '@ngrx/store';
import { conversationsQuery } from '@cigna/omni/conversations-state';
import { generateSummaryListItem } from '@cigna/omni/conversation-summary-list';

export const selectRecentActiveOrUnreadConversationSummaryListItem = createSelector(
  conversationsQuery.selectRecentActiveOrUnreadConversation,
  (item) => (item ? generateSummaryListItem(item) : null),
);
